import { render, staticRenderFns } from "./Ring.vue?vue&type=template&id=1dbd882a&"
import script from "./Ring.vue?vue&type=script&lang=js&"
export * from "./Ring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports